import { render } from "./LoginDialog.vue?vue&type=template&id=971f69cc&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=971f69cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971f69cc"],['__file',"src/components/auth/LoginDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "971f69cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('971f69cc', __exports__)) {
    api.reload('971f69cc', __exports__)
  }
  
  module.hot.accept("./LoginDialog.vue?vue&type=template&id=971f69cc&scoped=true", () => {
    api.rerender('971f69cc', render)
  })

}


export default __exports__